// extracted by mini-css-extract-plugin
export var sectionTitle = "about-section-module--section-title--ZETkd";
export var sectionParagraph = "about-section-module--section-paragraph--p6oRF";